var _rect, _rect2, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 25,
    height: 20,
    rx: 3.33333,
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 26,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 25,
    height: 20,
    rx: 3.33333,
    fill: "url(#paint0_linear_1451_18187)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9167 27.5L7.5 6.66663V27.5H27.9167Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 22.5,
    width: 25,
    height: 5,
    fill: "#5C5B5A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 27.5H16.6667V30.8333H15.8333C15.3731 30.8333 15 31.2064 15 31.6667C15 32.1269 15.3731 32.5 15.8333 32.5H24.1667C24.6269 32.5 25 32.1269 25 31.6667C25 31.2064 24.6269 30.8333 24.1667 30.8333H23.3333V27.5Z",
    fill: "#FF791C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1451_18187",
    x1: 10.4167,
    y1: 16.6667,
    x2: 28.75,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DBAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258BEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuDesktop);
export default __webpack_public_path__ + "static/media/wikiMenuDesktop.f0b48950e353c9984e2db38528da3cf9.svg";
export { ForwardRef as ReactComponent };